export default "__VITE_ASSET__DhrUCHfT__"